import type { ComponentPropsWithoutRef } from "react"
import { useMemo } from "react"
import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import {
  useReadableNearestGlucoseReading,
  useReadableGlucoseUnit,
} from "src/hooks"
import { sleepSettingToTime } from "src/utils"

interface Props extends ComponentPropsWithoutRef<"button"> {
  dayStart: string;
}

export function WakeUpGlucoseDayMetricComponent(props: Props) {
  const {
    dayStart,
    children,
    ...buttonProps
  } = props

  const polyglot = usePolyglot()

  const { currentFollow } = useFollowedUsers()
  const wakeUp = currentFollow.sleep_settings.end_time

  const time = useMemo(
    () => sleepSettingToTime(
      wakeUp,
      dayStart,
    ),
    [
      wakeUp,
      dayStart,
    ],
  )

  const reading = useReadableNearestGlucoseReading(
    currentFollow.following_account_id,
    time,
  )
  const glucoseUnit = useReadableGlucoseUnit()

  if (reading === undefined) {
    return null
  }

  const { readableValue } = reading

  return (
    <button {...buttonProps}>
      {children}
      {polyglot.t(
        "pages.home.activity_list.day_stats.glucose_wakeup",
        {
          glucoseUnit,
          glucoseValue: readableValue,
        },
      )}
    </button>
  )
}
